import { getIdToken, getIdTokenResult } from "firebase/auth";
import { auth } from "../firebase/firebase";

/**
 * Check if the current user has an active EmbroideryTrace membership.
 * Returns "embroiderytrace" if active, false otherwise.
 *
 * Checks for:
 *  - stripeRole === "embroiderytrace"  (set by Stripe Firebase Extension via product firebaseRole metadata)
 *  - embroideryRole === "active"       (alternative claim for custom webhook setups)
 */
export default async function isEmbroideryPremium() {
  if (!auth.currentUser) return false;

  try {
    await getIdToken(auth.currentUser, true);
    const decodedToken = await getIdTokenResult(auth.currentUser);
    const { stripeRole, embroideryRole } = decodedToken.claims;

    if (stripeRole === "embroiderytrace" || embroideryRole === "active") {
      return "embroiderytrace";
    }

    return false;
  } catch (error) {
    console.error("Error checking embroidery premium status:", error);
    return false;
  }
}
